import React from 'react';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';
import MainPage from '../../../composents/MainPage';

const title = 'Zones';
const headers = {
	icon: 'feather icon-droplet',
	title: title,
	description: 'track and manage all zones information',
};

export default function MeterPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					// { label: 'Group name', field: 'group' },
					{ label: 'Zone name', field: 'zone' },
					{
						label: 'Zone location',
						field: 'location',
					},
					{
						label: 'Client',
						field: 'client',
						render: ['name'],
					},
					{
						label: 'Note',
						field: 'description',
					},
				]}
				resource={resources.zone}
				title={title}
				link="/meters/zones"
			/>
		</MainPage>
	);
}
